import { render } from "./OrderCreateBatteryMKB.vue?vue&type=template&id=d3bbf310"
import script from "./OrderCreateBatteryMKB.vue?vue&type=script&lang=js"
export * from "./OrderCreateBatteryMKB.vue?vue&type=script&lang=js"

import "./OrderCreateBatteryMKB.vue?vue&type=style&index=0&id=d3bbf310&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__